export default "__VITE_ASSET__hGTt8yqR__"